import { connect } from 'react-redux'
import TripsHistoryColumnsMenu from '../../components/trips/TripsHistoryColumnsMenu'
import { actionCreators } from '../../state/actions/trips/index'
import { getTripsHistoryColumns } from '../../state/selectors/index'
import { IStoreState } from '../../types/index'

const mapStateToProps = (state: IStoreState, ownProps: any): any => {
  return {
    columns: getTripsHistoryColumns(state)
  }
}

const mapDispatchToProps = (dispatch: any): any => {
  return {
    onUpdateColumns: (columns: string[]) => {
      dispatch(actionCreators.tripsHistoryUpdateColumns(columns))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TripsHistoryColumnsMenu)



// WEBPACK FOOTER //
// ./src/containers/trips/TripsHistoryColumnMenu.ts